import React from 'react'
import SringharDarshan from "../components/darshans/Sringar";

const DailyDarshanGallery = () => {
    return (
        <SringharDarshan />
    )
}

export default DailyDarshanGallery


// import { useState, useEffect, useRef } from 'react';
// import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
// import { Splide, SplideSlide } from '@splidejs/react-splide';
// import Skeleton from 'react-loading-skeleton';
// import PageHeader from "../components/common/PageHeader";
// import GoToTop from "../helpers/GoToTop";
// import MetaData from "../helpers/MetaData";
// import ApiService from "../api/ApiService";
// import SringharDarshan from "../components/darshans/Sringar";

// const DailyDarshan = () => {
//     const [top, setTop] = useState(0);
//     const [galleries, setGalleries] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const festRef = (node) => {
//         if (node) {
//             setTop(node.offsetTop - 45);
//         }
//     };
//     const fetchGalleries = async () => {
//         try {
//             // In a production environment, this would be an API call
//             const data = [
//                 {
//                     id: 2,
//                     title: "Sringar Darshan",
//                     items: [
//                         {
//                             id: 1,
//                             title: "Sringar Darshan",
//                             date: "May 5, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/sringar-darshan-_82681847fb6b804.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-05-05/2/sringar-darshan"
//                         },
//                         {
//                             id: 2,
//                             title: "Sringar Darshan",
//                             date: "May 4, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/sringar-darshan_9468170bda9a065.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-05-04/2/sringar-darshan"
//                         },
//                         {
//                             id: 3,
//                             title: "Sringar Darshan",
//                             date: "May 3, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/sringar-darshan_766815ad2e3c111.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-05-03/2/sringar-darshan"
//                         },
//                         {
//                             id: 4,
//                             title: "Sringar Darshan",
//                             date: "May 2, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/sringar-darshan_10681464140a999.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-05-02/2/sringar-darshan"
//                         }
//                     ]
//                 },
//                 {
//                     id: 3,
//                     title: "Mangala Darshan",
//                     items: [
//                         {
//                             id: 1,
//                             title: "Mangal Aratik Darshan",
//                             date: "May 5, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/mangal-aratik-darshan_746818041a465b9.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-05-05/3/mangala-darshan"
//                         },
//                         {
//                             id: 2,
//                             title: "Mangal Aratik Darshan",
//                             date: "May 2, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/mangal-aratik-darshan_8368140fba1b51a.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-05-02/3/mangala-darshan"
//                         },
//                         {
//                             id: 3,
//                             title: "Mangal Aratik Darshan",
//                             date: "Apr 29, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/mangal-aratik-darshan-_3268101d73ca03c.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-04-29/3/mangala-darshan"
//                         },
//                         {
//                             id: 4,
//                             title: "Mangal Aratik Darshan",
//                             date: "Apr 26, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/mangal-aratik-darshan-_19680c2705aba01.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-04-26/3/mangala-darshan"
//                         }
//                     ]
//                 },
//                 {
//                     id: 4,
//                     title: "Festival Darshan",
//                     items: [
//                         {
//                             id: 1,
//                             title: "Chandan Yatra 2025",
//                             date: "Apr 30, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/chandan-yatra-2025_5068125c1c89bab.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-04-30/4/festival-darshan"
//                         },
//                         {
//                             id: 2,
//                             title: "Golden Jubilee Ramnavami 2025",
//                             date: "Apr 6, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/golden-jubilee-ramnavami-_2467f214cf57e81.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-04-06/4/festival-darshan"
//                         },
//                         {
//                             id: 3,
//                             title: "Golden Jubilee Day 5",
//                             date: "Apr 5, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/golden-jubilee-day-5--_8567f1075078eb6.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-04-05/4/festival-darshan"
//                         },
//                         {
//                             id: 4,
//                             title: "Golden Jubilee Day 4",
//                             date: "Apr 4, 2025",
//                             imageUrl: "https://iskcon-vrindavan.s3.ap-south-1.amazonaws.com/gallery_image/golden-jubilee-day-4_8967efcdc65b93e.jpg",
//                             linkUrl: "/daily-darshan-gallery/2025-04-04/4/festival-darshan"
//                         }
//                     ]
//                 }
//             ];
//             setGalleries(data);
//             setLoading(false);
//         } catch (error) {
//             console.log(error);
//             setLoading(false);
//         }
//     };

//     useEffect(() => {

//         fetchGalleries();

//     }, []);

//     // Calendar icon component
//     const CalendarIcon = () => (
//         <img
//             src="/images/common/calendar.svg"
//             alt="Calendar Icon"
//             className="w-5 h-5 text-gray-500"
//         />
//     );

//     // Individual gallery item card
//     const GalleryItem = ({ item }) => {
//         return (
//             <div className="flex flex-col">
//                 <div className="rounded-lg overflow-hidden mb-4">
//                     <img
//                         src={item.imageUrl}
//                         alt={item.title}
//                         className="w-full h-48 object-cover"
//                     />
//                 </div>
//                 <div className="bg-white p-4 rounded-lg flex-grow">
//                     <h3 className="font-bold text-gray-900 mb-2">
//                         {item.title}
//                     </h3>
//                     <div className="flex items-center mb-4">
//                         <CalendarIcon />
//                         <span className="ml-2 text-gray-600">{item.date}</span>
//                     </div>
//                     <a
//                         href={item.linkUrl}
//                         className="block w-full text-center py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
//                     >
//                         Explore Gallery
//                     </a>
//                 </div>
//             </div>
//         );
//     };
//     const GallerySection = ({ gallery }) => {
//         return (
//             <div className="mb-16">
//                 <div className="flex justify-between items-center mb-6">
//                     <h2 className="text-3xl font-bold text-gray-900">
//                         {gallery.title}
//                     </h2>
//                     <a href={`/daily-darshan-gallery/${gallery.title.toLowerCase().replace(/\s+/g, '-')}/${gallery.id}`}
//                         className="text-gray-700 hover:text-gray-900">
//                         See all
//                     </a>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//                     {gallery.items.map((item) => (
//                         <GalleryItem key={item.id} item={item} />
//                     ))}
//                 </div>
//             </div>
//         );
//     };
//     return (
//         <>
//             <MetaData title="Daily Darshan - ISKCON of Bhiwandi" />
//             <PageHeader title="Daily Darshan" imgSrc="/images/page-header/03.webp" />


//             {/* Darshan Gallery Sections */}
//             <section className="darshan-galleries">
//                 <div className="container py-12">
//                     {loading ? (
//                         <div className="flex justify-center items-center h-64">
//                             <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
//                             <span className="ml-2">Loading galleries...</span>
//                         </div>
//                     ) : (
//                         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//                             {galleries.map((gallery) => (
//                                 <div key={gallery.id} className="w-full">
//                                     <GallerySection gallery={gallery} />
//                                 </div>
//                             ))}
//                         </div>
//                     )}
//                 </div>
//             </section>


//             <GoToTop top={top} />
//         </>
//     );
// };

// export default DailyDarshan;